function getBaseUrl(): string {
  const hostname = window.location.hostname;

  // Map dealer portal hostname to its corresponding API hostname
  // dealer-beta.myarcticspa.com → dealer-api-beta.myarcticspa.com
  // dealer-beta.mycoldtub.com   → dealer-api-beta.mycoldtub.com
  // dealer.myarcticspa.com      → dealer-api.myarcticspa.com
  // dealer.mycoldtub.com        → dealer-api.mycoldtub.com
  if (hostname.startsWith('dealer.')) {
    const apiHostname = hostname.replace('dealer.', 'dealer-api.');
    return `https://${apiHostname}/api`;
  }
  if (hostname.startsWith('dealer-')) {
    const apiHostname = hostname.replace('dealer-', 'dealer-api-');
    return `https://${apiHostname}/api`;
  }

  // Fallback for local development
  return process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';
}

export const BASE_URL = getBaseUrl();